import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { PaginationComponent } from './pagination-component';

export const PaginationComponentModule: string = ng
    .module('pagination-component', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('paginationComponent', PaginationComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/pagination-component/pagination-component.module.ts